import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-edit-footer-text',
  templateUrl: './edit-footer-text.component.html',
  styleUrls: ['./edit-footer-text.component.scss']
})
export class EditFooterTextComponent implements OnInit, AfterViewInit {
  @Input() footerTextInfo: any;
  textForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private serviceModal: NgbActiveModal,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  ngAfterViewInit(): void {
    this.updateForm();
  }

  private createForm(): any {
    this.textForm = this.fb.group({
      name: ['', Validators.required],
      id: [0, Validators.required]
    });
  }

  private updateForm(): any {
    this.textForm.get('name').setValue(this.footerTextInfo.name);
    this.textForm.get('id').setValue(this.footerTextInfo.id);
  }

  sendData() {
    this.serviceModal.close(this.textForm.value);
  }
}
